var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "15px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索母液...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchSemi
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "220px",
      "margin-right": "12px"
    },
    attrs: {
      "placeholder": "工厂筛选",
      "label-in-value": "",
      "multiple": "",
      "filterable": "",
      "loading": _vm.loadingFactory
    },
    on: {
      "on-change": _vm.choseFactory
    },
    model: {
      value: _vm.selectedFactory,
      callback: function ($$v) {
        _vm.selectedFactory = $$v;
      },
      expression: "selectedFactory"
    }
  }, _vm._l(_vm.factoryList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c('Select', {
    staticStyle: {
      "width": "130px",
      "margin-right": "auto"
    },
    on: {
      "on-change": _vm.changeInvalid
    },
    model: {
      value: _vm.isShowInvalid,
      callback: function ($$v) {
        _vm.isShowInvalid = $$v;
      },
      expression: "isShowInvalid"
    }
  }, _vm._l(_vm.showInvalidList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalCounts) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalCounts,
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadSemiItem
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateSemiDrawer();
      }
    }
  }, [_vm._v("新增母液")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.semiItemList,
      "height": _vm.tableHeight
    }
  })], 1), _c('CreateSemiItemDrawer', {
    ref: "CreateSemiItemDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }